import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("sido_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ""}: ${x.msg}`).join(" ");
  return String(d);
}

export const fmtMoney = (v) => (v == null || v === "" ? null : `$${Number(v).toLocaleString()}`);
export const fmtNum = (v, suffix = "") => (v == null || v === "" ? null : `${Number(v).toLocaleString()}${suffix}`);
export const imgSrc = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export async function downloadBlob(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
